import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Button,
  Card,
  Label,
  Input,
  Progress,
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { post, put, get } from "../../../../api/axios";
import endpoints from "../../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import imgupload from "../../../../assets/images/imageupload.svg";

const EditEquipmentBrand = () => {
  document.title = "Edit Equipment Brand| Elevated - Admin Dashboard";
  const navigate = useNavigate();
  const { id } = useParams();
  const [cat, setCat] = useState();
  const validationSchema = Yup.object().shape({
    name: Yup.string()

      .max(30, "Title must not exceed 30 characters")
      .required("Title is required"),
  });

  const getCat = async () => {
    try {
      // Use Promise.all to handle all uploads
      const resp = await get(`${endpoints.brand}/${id}`);
      if (resp.data.success) {
        setCat(resp.data.data);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };
  useEffect(() => {
    getCat();
  }, []);
  const handleSubmit = async (values) => {
    try {
      // Use Promise.all to handle all uploads
      const resp = await put(`${endpoints.brand}/${id}`, {
        name: values.name,
        description: values.description,
      });

      if (resp?.data?.success) {
        // ✅ Success toast
        toast.success(
          resp?.data?.message || "Equipment Brand updated Successfully",
          {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          }
        );

        // Optionally navigate after success
        navigate(`/view-equipment-brand`);
      } else {
        toast.error(
          resp?.response?.data?.message || "Equipment Brand Not Added",
          {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          }
        );
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An unexpected error occurred while adding the brand";

      toast.error(errorMessage, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    } finally {
    }
  };
  const inputRef = useRef(null);

  return (
    <div className="mx-2">
      <Container fluid className="">
        <Row>
          <Card className="rounded-4 ">
            <Formik
              initialValues={{
                name: cat?.name || "",
                description: cat?.description,
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
              validateOnBlur={true}
            >
              {({
                errors,
                touched,
                resetForm,
                values,
                setFieldValue,
                isSubmitting,
              }) => (
                <Form className="p-4">
                  <h3 className="primary-black ff-sora font-size-20 fw-bold">
                    Update Equipment Brand
                  </h3>
                  <h5 className="secondary-black ff-sora mt-4 font-size-16 fw-600">
                    Brand Name
                  </h5>
                  <div>
                    <FormGroup className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <Field
                        style={{
                          width: "100%",
                          maxWidth: "412px",
                          height: "56px",
                          border: "none",
                        }}
                        name={`name`}
                        as={Input}
                        placeholder="Equipment Brand Name"
                        className={`rounded-5 bg-light custom-placeholder ff-sora font-size-16 fw-normal px-4  ${
                          errors.title && touched.title ? "is-invalid" : ""
                        }`}
                      />
                      <ErrorMessage
                        name={`name`}
                        component="div"
                        className="text-danger ff-sora font-size-12 fw-normal"
                      />
                    </FormGroup>
                  </div>

                  <h5 className="secondary-black ff-sora mt-4 font-size-16 fw-600">
                    Description
                  </h5>
                  <div>
                    <FormGroup className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <Field
                        style={{
                          width: "100%",
                          maxWidth: "412px",
                          height: "56px",
                          border: "none",
                        }}
                        name={`description`}
                        as={Input}
                        placeholder="Equipment Brand Description"
                        className={`rounded-5 bg-light custom-placeholder ff-sora font-size-16 fw-normal px-4  ${
                          errors.title && touched.title ? "is-invalid" : ""
                        }`}
                      />
                      <ErrorMessage
                        name={`description`}
                        component="div"
                        className="text-danger ff-sora font-size-12 fw-normal"
                      />
                    </FormGroup>
                  </div>
                  <div className="d-flex float-end">
                    <Button
                      type="submit"
                      className="me-2 rounded-pill"
                      disabled={isSubmitting}
                    >
                      Update Category
                    </Button>
                    <Button
                      color="white"
                      className="rounded-pill1"
                      onClick={() => {
                        resetForm();

                        navigate(`/view-equipment-brand`);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Card>
        </Row>
      </Container>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "60px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </div>
  );
};

export default EditEquipmentBrand;
